import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import Box, { BoxProps } from '@classify/react-core-components/Box';
import { SxProps, Theme } from '@classify/react-core-components/styles';
export enum MediaFormats {
  isSquare = 'isSquare',
  isSquareVideoAnimation = 'isSquareVideoAnimation',
  isVideo = 'isVideo',
  isFourThirds = 'isFourThirds',
}
export interface Props extends BoxProps {
  children: ReactNode;
  format?: MediaFormats;
  sx?: SxProps<Theme>;
}
const HeroMediaContainer = t0 => {
  const $ = _c(17);
  const {
    format,
    children,
    sx
  } = t0;
  let style;
  let wrapperStyle;
  bb0: switch (format) {
    case MediaFormats.isSquare:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            alignSelf: "center",
            width: {
              xs: 252,
              sm: 360,
              lg: 416
            },
            "&, > :first-of-type": {
              maxWidth: "100%",
              display: "block",
              marginRight: "auto",
              marginLeft: "auto",
              height: "auto"
            }
          };
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        style = t1;
        break bb0;
      }
    case MediaFormats.isSquareVideoAnimation:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            xs: 252,
            sm: 360,
            lg: 416
          };
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            alignSelf: "center",
            lineHeight: 0,
            width: t1,
            marginRight: "auto",
            marginLeft: "auto",
            "& > div": {
              width: {
                xs: 252,
                sm: 360,
                lg: 416
              },
              position: "relative",
              paddingTop: "100%",
              height: 0
            },
            "& > div > img, & > div > div": {
              border: 0,
              position: "absolute",
              objectFit: "contain",
              width: "100% !important",
              height: "100%",
              top: 0,
              left: 0
            }
          };
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        style = t2;
        break bb0;
      }
    case MediaFormats.isVideo:
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            xs: "100%",
            sm: 704,
            md: 400,
            lg: 568
          };
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            alignSelf: "center",
            width: t1,
            position: "relative",
            paddingTop: "56.41%",
            height: 0,
            "& > iframe:first-of-type, & > video:first-of-type": {
              border: 0,
              position: "absolute",
              objectFit: "contain",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0
            }
          };
          $[4] = t2;
        } else {
          t2 = $[4];
        }
        wrapperStyle = t2;
        let t3;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = {
            alignSelf: "center",
            width: {
              xs: "100%",
              sm: 704,
              md: 400,
              lg: 568
            }
          };
          $[5] = t3;
        } else {
          t3 = $[5];
        }
        style = t3;
        break bb0;
      }
    case MediaFormats.isFourThirds:
    default:
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            alignSelf: "center",
            width: {
              xs: 328,
              sm: 480,
              md: 400,
              lg: 568
            },
            "&, > :first-of-type": {
              maxWidth: "100%",
              display: "block",
              marginRight: "auto",
              marginLeft: "auto",
              height: "auto"
            }
          };
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        style = t1;
      }
  }
  let t1;
  if ($[7] !== style || $[8] !== sx) {
    t1 = {
      ...style,
      ...sx
    };
    $[7] = style;
    $[8] = sx;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== children || $[11] !== format || $[12] !== wrapperStyle) {
    t2 = format === MediaFormats.isVideo ? <Box data-testid="narrative-media-container-video-inner-wrapper" sx={wrapperStyle}>{children}</Box> : children;
    $[10] = children;
    $[11] = format;
    $[12] = wrapperStyle;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t1 || $[15] !== t2) {
    t3 = <Box data-testid="narrative-media-container-root" sx={t1}>{t2}</Box>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};
export default HeroMediaContainer;